import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HeroSec = () => {
  const data = ["Myntra", "Amazon", "AJIO", "Flipkart", "Nykaa"];
  const [currentWord, setCurrentWord] = useState("");
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const typingSpeed = isDeleting ? 150 : 150;
    const timeout = setTimeout(() => {
      if (!isDeleting && charIndex < data[index].length) {
        // Add the next character
        setCharIndex(charIndex + 1);
        setCurrentWord(data[index].substring(0, charIndex + 1));
      } else if (isDeleting && charIndex > 0) {
        // Remove a character
        setCharIndex(charIndex - 1);
        setCurrentWord(data[index].substring(0, charIndex - 1));
      } else if (!isDeleting && charIndex === data[index].length) {
        // Start deleting after a delay
        setTimeout(() => {
          setIsDeleting(true);
        }, 1000);
      } else if (isDeleting && charIndex === 0) {
        // Move to the next word
        setIsDeleting(false);
        setIndex((index + 1) % data.length);
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, index, data]);

  return (
    <div className="flex flex-row items-center gap-8 -mt-8 sm:-mt-4 md:-mt-12">
      <img
        src="/img/webpImg/bg.webp"
        alt="background image"
        className="absolute top-0 right-0 w-full middle:w-[80%] hidden sm:block z-[-10]"
      />
      <div className="w-full sm:w-[50%] flex flex-col gap-6">
        <div className="flex flex-col items-center gap-4 mt-10 mb-6 text-center sm:text-start sm:items-start">
          <h1 className="text-[#000] text-[24px] md:text-[48px] leading-[119%] max-w-[250px] md:max-w-[350px] font-medium sm:font-normal sm:leading-[115%]">
            Steal The <span className="sm:font-bold">Best Deals</span>
            <span className="mr-[100px] sm:mr-0"> from</span>
            <span className="text-[#7E54F2] font-bold ml-[-95px] sm:ml-2 absolute">
              {currentWord}
            </span>
          </h1>
          <img
            src="/img/webpImg/vector.webp"
            alt="Image"
            className="block sm:hidden"
          />
          <p className="text-[#000] text-[16px] md:text-[22px] leading-[130%] flex flex-col gap-y-1">
            Grab Every Deal You Love… <span>From Every Store You Love!!</span>
          </p>
        </div>
        <div className="items-center hidden gap-5 sm:flex">
          <Link
            className="cursor-pointer"
            to="https://apps.apple.com/in/app/tbd-the-deals-app/id6741994389"
            target="_blank"
          >
            <img
              src="/img/webpImg/Apple-Store-Button.webp"
              alt="download option"
              className="w-[130px]"
            />
            {/* <p className="text-sm text-center opacity-70">coming soon</p> */}
          </Link>
          <div>
            <Link
              className="cursor-pointer"
              to="https://play.google.com/store/apps/details?id=com.the_best_dealsApp"
              target="_blank"
            >
              <img
                src="/img/webpImg/Google-Play-Button.webp"
                alt="download option"
                className="w-[130px]"
              />
            </Link>
            {/* <p className="opacity-0">h</p> */}
          </div>
        </div>
      </div>

      <div className="relative w-[40%] hidden sm:flex justify-center items-center">
        {/* Main Phone Image */}
        <div className="relative">
          <img
            src="/img/webpImg/HeroSec.webp"
            alt="hero section image"
            className="w-full h-full"
          />

          {/* Floating Icons */}
          <img
            src="/img/webpImg/ajio.webp"
            alt="AJIO"
            className="absolute top-[10%] right-[10%] w-[40px] sm:w-[38px] md:w-[45px] lg:w-[50px] xl:w-[60px]"
          />
          <img
            src="/img/webpImg/myntra.webp"
            alt="Myntra"
            className="absolute top-[15%] right-[-10%] w-[40px] sm:w-[38px] md:w-[45px] lg:w-[50px] xl:w-[60px]"
          />
          <img
            src="/img/webpImg/nykaa.webp"
            alt="Nykaa"
            className="absolute top-[34%] right-[-15%] w-[40px] sm:w-[38px] md:w-[45px] lg:w-[50px] xl:w-[60px]"
          />
          <img
            src="/img/webpImg/amazon.webp"
            alt="Amazon"
            className="absolute top-[53%] right-[-15%] w-[40px] sm:w-[38px] md:w-[45px] lg:w-[50px] xl:w-[60px]"
          />
          <img
            src="/img/webpImg/quora.webp"
            alt="Quora"
            className="absolute bottom-[15%] right-[-10%] w-[40px] sm:w-[38px] md:w-[45px] lg:w-[50px] xl:w-[60px]"
          />
          <img
            src="/img/webpImg/flipkart.webp"
            alt="Flipkart"
            className="absolute bottom-[10%] right-[10%] w-[40px] sm:w-[38px] md:w-[45px] lg:w-[50px] xl:w-[60px]"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSec;
